import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './ContaPJPromo.module.css';
const stepNumberStateClass = {
    done: styles.stepNumberDone,
    current: styles.stepNumberCurrent,
    pending: styles.stepNumberPending,
};
const stepTitleStateClass = {
    done: styles.stepTitleDone,
    current: styles.stepTitleCurrent,
    pending: styles.stepTitlePending,
};
const stepStateClass = {
    done: styles.stepDone,
    current: styles.stepCurrent,
    pending: styles.stepPending,
};
export function AccountOpeningSteps({ steps, dataTestId }) {
    return (_jsx("div", { className: styles.steps, "data-testid": dataTestId, children: steps.map((step, index) => (_jsxs("div", { className: `${styles.step} ${stepStateClass[step.state]}`, children: [_jsx("div", { className: `${styles.stepNumber} ${stepNumberStateClass[step.state]}`, children: index + 1 }), _jsxs("div", { className: styles.stepContent, children: [_jsx("h3", { className: `${styles.stepTitle} ${stepTitleStateClass[step.state]}`, children: step.title }), _jsx("p", { className: styles.stepDescription, dangerouslySetInnerHTML: { __html: step.description } })] })] }, `${step.title}-${index}`))) }));
}
